export const customStyles = {
  dropdown: {
    minHeight: 0,
    paddingHorizontal: 0,
    paddingVertical: 0,
    borderRadius: 0,
    borderWidth: 0,
    borderColor: 'transparent',
  },
  dropdownText: {
    fontSize: 16,
  },
  dropdownPlaceholder: {
    color: '#94A3B8',
    fontFamily: 'Poppins',
    fontSize: 16,
  },
  dropdownContainer: {
    borderRadius: 8,
    borderWidth: 0,
    borderColor: 0,
    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1), 0px 1px 5px rgba(0, 0, 0, 0.06)',
    zIndex: 5001,
  },
  dropdownSearch: {
    borderBottomWidth: 0,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  dropdownSearchText: {
    fontFamily: 'Poppins',
    fontSize: 14,
  },
  dropdownDisabled: {
    backgroundColor: '#E2E8F0',
  },
  dropdownItemLabel: {
    fontFamily: 'Poppins',
  },
};